/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdBasicDataMutationRequest,
  PutApiV1PersonIdBasicDataMutationResponse,
  PutApiV1PersonIdBasicDataPathParams,
  PutApiV1PersonIdBasicData400,
  PutApiV1PersonIdBasicData401,
  PutApiV1PersonIdBasicData404,
  PutApiV1PersonIdBasicData409,
  PutApiV1PersonIdBasicData500,
} from "../../types/personRegisterController/PutApiV1PersonIdBasicData.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdBasicData } from "../../clients/personRegisterController/putApiV1PersonIdBasicData.ts";

export const putApiV1PersonIdBasicDataMutationKey = () =>
  [{ url: "/api/v1/person/:id/basic-data" }] as const;

export type PutApiV1PersonIdBasicDataMutationKey = ReturnType<
  typeof putApiV1PersonIdBasicDataMutationKey
>;

export function putApiV1PersonIdBasicDataMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1PersonIdBasicDataMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1PersonIdBasicDataMutationKey();
  return mutationOptions<
    PutApiV1PersonIdBasicDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdBasicData400
      | PutApiV1PersonIdBasicData401
      | PutApiV1PersonIdBasicData404
      | PutApiV1PersonIdBasicData409
      | PutApiV1PersonIdBasicData500
    >,
    {
      id: PutApiV1PersonIdBasicDataPathParams["id"];
      data?: PutApiV1PersonIdBasicDataMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdBasicData(id, data, config);
    },
  });
}

/**
 * @description Atualiza parcialmente os dados básicos de uma pessoa. Apenas os campos informados serão alterados. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados básicos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/basic-data}
 */
export function usePutApiV1PersonIdBasicData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdBasicDataMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdBasicData400
        | PutApiV1PersonIdBasicData401
        | PutApiV1PersonIdBasicData404
        | PutApiV1PersonIdBasicData409
        | PutApiV1PersonIdBasicData500
      >,
      {
        id: PutApiV1PersonIdBasicDataPathParams["id"];
        data?: PutApiV1PersonIdBasicDataMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdBasicDataMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdBasicDataMutationKey();

  const baseOptions = putApiV1PersonIdBasicDataMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdBasicDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdBasicData400
      | PutApiV1PersonIdBasicData401
      | PutApiV1PersonIdBasicData404
      | PutApiV1PersonIdBasicData409
      | PutApiV1PersonIdBasicData500
    >,
    {
      id: PutApiV1PersonIdBasicDataPathParams["id"];
      data?: PutApiV1PersonIdBasicDataMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdBasicDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdBasicData400
      | PutApiV1PersonIdBasicData401
      | PutApiV1PersonIdBasicData404
      | PutApiV1PersonIdBasicData409
      | PutApiV1PersonIdBasicData500
    >,
    {
      id: PutApiV1PersonIdBasicDataPathParams["id"];
      data?: PutApiV1PersonIdBasicDataMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdBasicDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdBasicData400
      | PutApiV1PersonIdBasicData401
      | PutApiV1PersonIdBasicData404
      | PutApiV1PersonIdBasicData409
      | PutApiV1PersonIdBasicData500
    >,
    {
      id: PutApiV1PersonIdBasicDataPathParams["id"];
      data?: PutApiV1PersonIdBasicDataMutationRequest;
    },
    TContext
  >;
}
